export default __webpack_public_path__ + "pgnv-assets/493e139e7146cfa94b4195d26df99622.svg";